import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const FieldActivityPlotwiseDetailReport = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/standardreport");
  };
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [farmActivityData, setFarmActivityData] = useState([]);
  const [farmActivityId, setFarmActivityId] = useState();

  const [plotData, setPlotData] = useState([]);

  const [plotId, setPlotId] = useState();

  const { sendRequest: getWarehouseData } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const loadCountData = (id) => {
    FillReport(id);
  };

  const FillReport = (employeeId, regionId) => {
    // //console.log("selectedFromDate", selectedFromDate);
    // //console.log("selectedToDate", selectedToDate);
    // var df = new Date(selectedFromDate);
    // var dt = new Date(selectedToDate);
    // df.setDate(df.getDate() -1);
    // dt.setDate(dt.getDate() +1);

    // var fdate =moment(df).format("DD/MM/YYYY");
    // var tdate =moment(dt).format("DD/MM/YYYY");
    setCurrentPage(1);
    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    var tdate = moment(selectedToDate).format("DD/MM/YYYY");
    setCurrentPage(1);
    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (plotId > 0) {
      urlfilter = urlfilter + `&plotId=${plotId}`;
    }

    // if (regionId > 0) {
    //   urlfilter = urlfilter + `&regionId=${regionId}`;
    // }

    var url = `/api/fieldActivityMIS/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        //console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReport(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=CommercialFarming&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  }, [getEmp]);

  const { sendRequest: getplotDetails } = useHttp();

  const plotDetail = (empId) => {
    var urlfilter = "";

    if (empId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${empId}`;
    }

    getplotDetails(
      {
        url: `/api/plotDetails/?orgId=${localStorage.getItem(
          "orgId"
        )}${urlfilter} `,
      },
      (data) => {
        var plotlist = data; //data.output.filter((item) => item.useCase == "Procurement");

        setPlotData(plotlist);
      }
    );
  };

  useEffect(() => {
    plotDetail(0);
  }, [getplotDetails]);

  const fieldsToExport = [
    "startDate",
    "FieldActivityNo",
    "farmManager",
    "plotName",
    "plotArea",
    "plotAreaUnit",
    "cropName",
    "varietyName",
    "sowingDate",
    "actualStartDate",
    "actualStartTime",
    "temperature",
    "weather",
    "areaCovered",
    "areaCoveredUnit",
    "fieldActivityName",
    "inputProductCost",
    "labourDetails.costIncurred",
    "machineCost",
    "endDate",
    "endTime",
    "duration",
    "timeTaken",
    "reasonForExtraTime",
    "status",
  ];

  const customHeaders = [
    "Plan Date",
    "Field Activity No",
    "Farm Manager",
    "Plot Name",
    "Plot Area",
    "Unit",
    "Crop Name",
    "Variety Name",
    "Sowing Date",
    "Start Date",
    "Start Time",
    "Temperature",
    "Weather",
    "Area Covered",
    "Area Covered Unit",
    "Activity Name",
    "Inputs Product Cost",
    "Labour Cost",
    "Machine Cost",
    "End Date",
    "End Time",
    "Duration",
    "Time Taken",
    "Reason For Extra Time",
    "Status",
  ];

  const handleExportExcel = () => {
    const filename = "FieldActivityPlotwise.xlsx";

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              {" "}
              Field Activity Plotwise Detail Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <hr />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                      plotDetail(e.target.valueer);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Plot </label>

                  <select
                    id="plotId"
                    className="form-control"
                    ref={(el) => (frmRef.current["plotId"] = el)}
                    value={plotId}
                    onChange={(e) => {
                      setPlotId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {plotData &&
                      plotData.map((x) => (
                        <option
                          key={x.plotId}
                       
                          value={x.plotId}
                        >
                          {x.plotName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                  
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                   
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReport(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              </div>
            {/* <div className="row">
           
            <div className="col-md-3">
            <div className="form-group">
            <label htmlFor={"executive_officer"}>{"Procurement Officer"}</label>
            <select
              id="emp_id"
              className="form-control"
              ref={(el) => (frmRef.current["emp_id"] = el)}
              value={employeeId}
              onChange={(e) => {
                var userid = 0;
                if (e.target.value != "--Select--") userid = e.target.value;

                setEmployeeId(userid);
                plotDetail(userid);
                setData([]);
              }}
            >
              <option>--Select--</option>
              {employeeData &&
                employeeData.map((x) => (
                  <option key={x.userId} user-id={x.userId} value={x.userId}>
                    {x.employeeName}
                  </option>
                ))}
            </select>
          </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">


            <label >Plot </label>
            
            <select
              id="plotId"
              className="form-control"
              ref={(el) => (frmRef.current["plotId"] = el)}
              value={plotId}
              onChange={(e) => {
                var plotId1 = 0;
                if (e.target.value != "--Select--") plotId1 = e.target.value;
                setPlotId(plotId1);
                setData([]);
              }}
            >
              <option>--Select--</option>
              {plotData &&
                plotData.map((x) => (
                  <option key={x.plotId} plot-Id={x.plotId} value={x.plotId}>
                    {x.plotName}
                  </option>
                ))}
            </select>

             
            </div>
            </div>

          <div className="col-md-2">
            <div className="form-group">
            {" "}
            <label htmlFor={"from_date"}>{"From Date"}</label>
            <input
              type={"date"}
              id={"date"}
              required
              // ref={(el) => (frmRef.current["pdate"] = el)}
              className="form-control"
              max={currentDate}
              value={selectedFromDate}
              onChange={handleFDateChange}
            />
          </div>

          </div>
          <div className="col-md-2">
            <div className="form-group">
            <label  >{"To Date"}</label>

            <input
              type={"date"}
              id={"date"}
              required
              // ref={(el) => (frmRef.current["pdate"] = el)}
              className="form-control"
              max={currentDate}
              value={selectedToDate}
              onChange={handleTDateChange}
            />
          </div>

           
          </div>
          <div className="col-md-2">
            <div className="form-group">
               
               <label>&nbsp;</label>
                <button
                  className="form-control btn btn-sm btn-primary"
                  onClick={(e) => {
                    FillReport(employeeId,regionId);
                  }}
                >
                  Submit
                </button>
              </div>
              </div>
              </div> */}
          </div>
          <h4>Please select the parameters to get the desired result</h4>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th> Plan Date </th>
                          <th> FieldActivityNo </th>
                          <th>Farm Manager</th>

                          <th>Plot Name </th>
                          <th> Plot Area </th>
                          <th> Unit </th>
                          <th> Crop Name </th>
                          <th>Variety Name </th>
                          <th> Sowing Date </th>
                          <th> Start Date </th>
                          <th> Start Time </th>
                          <th> Temperature </th>
                          <th> Weather </th>
                          <th> Area Covered </th>
                          <th> Unit</th>
                          <th> Activity Name </th>

                          <th> Inputs Product Cost </th>
                          <th> Labour Cost </th>
                          <th> Machine Cost </th>
                          <th> End Date </th>
                          <th> End Time </th>
                          <th> Duration </th>
                          <th>Time Taken</th>
                          <th> Reason For Extra Time </th>
                          <th> Status </th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.startDate}</td>
                                <td>{itm.FieldActivityNo}</td>

                                <td>{itm.farmManager}</td>

                                <td>{itm.plotName}</td>

                                <td> {itm.plotArea} </td>
                                <td> {itm.plotAreaUnit} </td>
                                <td> {itm.cropName} </td>
                                <td> {itm.varietyName} </td>
                                <td> {itm.sowingDate} </td>
                                <td> {itm.actualStartDate} </td>
                                <td> {itm.actualStartTime} </td>

                                <td> {itm.temperature} </td>
                                <td> {itm.weather} </td>
                                <td> {itm.areaCovered} </td>
                                <td> {itm.areaCoveredUnit} </td>
                                <td> {itm.fieldActivityName} </td>
                                <td> {itm.inputProductCost} </td>

                                <td>
                                  {" "}
                                  {itm.labourDetails &&
                                    itm.labourDetails.costIncurred}{" "}
                                </td>

                                <td> {itm.machineCost} </td>

                                <td> {itm.endDate} </td>
                                <td> {itm.endTime} </td>
                                <td> {itm.duration} </td>
                                <td> {itm.timeTaken} </td>
                                <td> {itm.reasonForExtraTime} </td>
                                <td>
                                  {" "}
                                  {itm.endDate && itm.endDate != ""
                                    ? "Completed"
                                    : itm.actualStartDate &&
                                      itm.actualStartDate != ""
                                    ? "In progress"
                                    : "Planned"}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FieldActivityPlotwiseDetailReport;
